/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const policyComplianceEnumsSubCategoryEnum = {
    InternalPolicyViolation: 'InternalPolicyViolation',
    ComplianceObligationsViolation: 'ComplianceObligationsViolation',
    DocumentsNotUpdatedOrNotFollowed: 'DocumentsNotUpdatedOrNotFollowed',
    ProcessNotFollowed: 'ProcessNotFollowed',
    Other: 'Other',
} as const;

export type PolicyComplianceEnumsSubCategoryEnumKey =
    (typeof policyComplianceEnumsSubCategoryEnum)[keyof typeof policyComplianceEnumsSubCategoryEnum];

export type PolicyComplianceEnumsSubCategory = PolicyComplianceEnumsSubCategoryEnumKey;
